import React from 'react'

import {
  IconSale,
  Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

function PriceIcon() {
  return <IconSale width="24" height="24" />
}

function DiscountIcon() {
  return (
    <Icon
      color="dark"
      notSpaced
      size="tiny"
      svgComponent={PriceIcon}
      className="wayfinder__action-icon-svg"
    />
  )
}

export default DiscountIcon
